import {accordionStyles} from '@amblique/king-living/app/theme/contentful/accordion';
import {accordionPanelStyles} from '@amblique/king-living/app/theme/contentful/accordion-panel';
import {actionLinksStyles} from '@amblique/king-living/app/theme/contentful/action-links';
import {blogStyles} from '@amblique/king-living/app/theme/contentful/blog';
import {blogGridStyles} from '@amblique/king-living/app/theme/contentful/blog-grid';
import {blogSummaryStyles} from '@amblique/king-living/app/theme/contentful/blog-summary';
import {breadcrumbStyles} from '@amblique/king-living/app/theme/contentful/breadcrumb';
import {carouselItemStyles} from '@amblique/king-living/app/theme/contentful/carousel-item';
import {containerStyles} from '@amblique/king-living/app/theme/contentful/container';
import {embedPanelStyles} from '@amblique/king-living/app/theme/contentful/embed-panel';
import {heroBannerStyles} from '@amblique/king-living/app/theme/contentful/hero-banner';
import {iconStyles} from '@amblique/king-living/app/theme/contentful/icon';
import {iconSetStyles} from '@amblique/king-living/app/theme/contentful/icon-set';
import {imageStyles} from '@amblique/king-living/app/theme/contentful/image';
import {linkStyles} from '@amblique/king-living/app/theme/contentful/link';
import {mediaCarouselStyles} from '@amblique/king-living/app/theme/contentful/media-carousel';
import {promoBannerStyles} from '@amblique/king-living/app/theme/contentful/promo-banner';
import {promoBannerItemStyles} from '@amblique/king-living/app/theme/contentful/promo-banner-item';
import {richTextBlockStyles} from '@amblique/king-living/app/theme/contentful/rich-text-block';
import {sectionPanelStyles} from '@amblique/king-living/app/theme/contentful/section-panel';
import {showroomDetailsStyles} from '@amblique/king-living/app/theme/contentful/showroom-details';
import {ugcBlockStyles} from '@amblique/king-living/app/theme/contentful/ugc-block';
import {splitPanelDoubleImageBlockStyles} from '@amblique/king-living/app/theme/contentful/split-panel-double-image-block';
import {teaserTileBlockStyles} from '@amblique/king-living/app/theme/contentful/teaser-tile-block';
import {videoStyles} from '@amblique/king-living/app/theme/contentful/video';

export const contentfulStyles = {
  'contentful/accordion': accordionStyles,
  'contentful/accordion-panel': accordionPanelStyles,
  'contentful/action-links': actionLinksStyles,
  'contentful/blog': blogStyles,
  'contentful/blog-grid': blogGridStyles,
  'contentful/blog-summary': blogSummaryStyles,
  'contentful/breadcrumb': breadcrumbStyles,
  'contentful/carousel-item': carouselItemStyles,
  'contentful/container': containerStyles,
  'contentful/embed-panel': embedPanelStyles,
  'contentful/hero-banner': heroBannerStyles,
  'contentful/icon': iconStyles,
  'contentful/icon-set': iconSetStyles,
  'contentful/image': imageStyles,
  'contentful/link': linkStyles,
  'contentful/media-carousel': mediaCarouselStyles,
  'contentful/promo-banner': promoBannerStyles,
  'contentful/promo-banner-item': promoBannerItemStyles,
  'contentful/rich-text-block': richTextBlockStyles,
  'contentful/section-panel': sectionPanelStyles,
  'contentful/showroom-details': showroomDetailsStyles,
  'contentful/ugc-block': ugcBlockStyles,
  'contentful/split-panel-double-image-block': splitPanelDoubleImageBlockStyles,
  'contentful/teaser-tile-block': teaserTileBlockStyles,
  'contentful/video': videoStyles,
};
